import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MATERIAL_MODULES } from '@shared/material';
import { IviMemoriesComponent } from './ivi-memories.component';

// Same isolation pattern as IviConnectionsModule (DEV-3829 SharedModule JIT
// circular-import trap): own tiny NgModule, imported into SharedModule's
// `imports` only so MatDialog.open(IviMemoriesComponent, …) can resolve it.
@NgModule({
    imports: [CommonModule, ...MATERIAL_MODULES],
    declarations: [IviMemoriesComponent],
    exports: [IviMemoriesComponent]
})
export class IviMemoriesModule {}
